import { useQuery } from '@tanstack/react-query';
import useFetchedSinceOpened from 'src/common/hooks/useFetchedSinceOpened';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import type { CustomSkill } from '../types';

/** `onLoadFailed` runs when the skill cannot be loaded on opening, after the user has been told. */
export default function useCustomSkill(
  companyId: string,
  skillId: string | null,
  onLoadFailed?: () => void,
) {
  const query = useQuery<CustomSkill>({
    queryKey: ['admin', 'companies', companyId, 'custom-skills', skillId],
    enabled: skillId !== null,
  });
  // A skill can change outside the editor (an approved Siesta proposal, the library, another tab),
  // and the editor takes its values once, so it opens only on a copy fetched since it was opened.
  const freshSkill = useFetchedSinceOpened(query, skillId, error => {
    notifyAndLogError("Couldn't load this skill", 'Please try again.', error);
    onLoadFailed?.();
  });
  return { ...query, freshSkill };
}
